import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 px-6 sm:px-12 md:px-24 py-16">
      <div className="max-w-4xl mx-auto space-y-12">
        {/* Heading */}
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-8 text-center text-gray-900">
          Privacy Policy
        </h1>

        {/* Intro */}
        <p className="text-gray-600 text-lg leading-relaxed">
          At <span className="text-black font-semibold">Twin Star Industries</span>,
          your privacy is very important to us. This Privacy Policy explains how
          we collect, use, and safeguard your personal information when you use
          our services.
        </p>

        {/* Section 1 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            1. Information We Collect
          </h2>
          <p className="text-gray-600 leading-relaxed">
            We may collect personal details such as your name, email address,
            phone number, and any other information you provide when contacting
            us or using our services.
          </p>
        </div>

        {/* Section 2 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            2. How We Use Your Information
          </h2>
          <p className="text-gray-600 leading-relaxed">
            The information we collect is used to:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-2 mt-2">
            <li>Provide and improve our services</li>
            <li>Respond to your inquiries</li>
            <li>Send updates and promotional materials (if opted-in)</li>
          </ul>
        </div>

        {/* Section 3 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            3. Sharing of Information
          </h2>
          <p className="text-gray-600 leading-relaxed">
            We do not sell or trade your personal information. We may share
            information only with trusted third parties who assist us in
            operating our services, as long as they agree to keep it
            confidential.
          </p>
        </div>

        {/* Section 4 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            4. Your Rights
          </h2>
          <p className="text-gray-600 leading-relaxed">
            You have the right to request access, correction, or deletion of
            your personal data at any time by contacting us directly.
          </p>
        </div>

        {/* Section 5 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            5. Changes to This Policy
          </h2>
          <p className="text-gray-600 leading-relaxed">
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with the updated date.
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-900">
            6. Contact Us
          </h2>
          <p className="text-gray-600 leading-relaxed">
            If you have any questions regarding this Privacy Policy, feel free
            to contact us at:{" "}
            <span className="text-black font-semibold">info@twinstar.com</span>
          </p>
        </div>

        {/* Footer Note */}
        <p className="text-gray-500 text-sm text-center mt-12">
          © {new Date().getFullYear()} Twin Star Industries. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
